<template>
    <div class='tab-content'>
        <div class='settings-container'>
            <div class="line">
                <span class="tit">
                    기기 ID<span class="imp">*</span>
                </span>

                <div class="mt-4">
                    <input v-model="config.deviceId" class="w200" required type="text" maxlength='255' />
                </div>
            </div>

            <div class="line">
                <span class="tit">
                    VAN TID<span class="imp">*</span>
                </span>

                <div class="mt-4">
                    <input v-model="config.vanTid" class="w200" required type="text" maxlength='12' />
                </div>
            </div>

            <div class="line">
                <span class="tit">
                    비밀번호<span class="imp">*</span>
                </span>

                <div class="mt-4">
                    <input v-model="config.secret" class="w200" required type="text" maxlength='12' />
                </div>
            </div>

            <div class="bottom-btn">
                <button :disabled="isLoading" class="com-btn" type="submit" @click="onCancel">취소</button>
                <button :disabled="isLoading" class="com-btn blue" type="submit" @click="onSubmit">저장</button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

import api from '@/assets/js/api';

export default {
    name: 'DeviceScreen',

    data() {
        return {
            isLoading: false,

            centerName: '',

            config: {
                deviceId: '',
                vanTid: '',
            }
        }
    },

    computed: {
        ...mapState({
            centerId: (state) => state.auth.user.centerId,
        }),
    },

    mounted() {
        this.getCenter();
        this.getKioskSetting();
    },

    methods: {
        async getCenter() {
            const { data } = await api.get(`/admin/api/center/${this.centerId}`);

            this.centerName = data.centerName;
        },

        async getKioskSetting() {
            this.isLoading = true;

            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}/kiosk/config`);

                this.config.deviceId = data.deviceId;
                this.config.vanTid = data.vanTid;
            } catch (e) {
                alert('로딩에 실패하였습니다.');
            }

            this.isLoading = false;
        },

        async onCancel() {
            await this.getKioskSetting();
        },

        async onSubmit() {
            this.isLoading = true;

            const params = { ...this.config };

            try {
                await api.post(`/admin/api/center/${this.centerId}/kiosk/config`, params);

                alert('저장했습니다.');
            } catch (e) {
                console.error(e);
                alert('저장에 실패했습니다.');
            }

            this.isLoading = false;
        }
    }
}
</script>

<style scoped>

.preview .cover {
    position: absolute;
    width: 476px;
    height: 318px;
    top: 101px;
    left: 50%;
    transform: translateX(-50%);
}

.preview .title {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}

.title span {
    font-size: 20px;
    font-weight: 500;
    color: white;
    max-width: 60%;
    white-space: nowrap;
    overflow: hidden;
}


.preview .headline {
    position: absolute;
    top: 447px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}

.headline span {
    font-size: 20px;
    font-weight: 500;
    color: #111827;
    max-width: 60%;
    white-space: nowrap;
    overflow: hidden;
}

.preview .subtitle {
    position: absolute;
    top: 486px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}

.subtitle span {
    display: inline-block;
    font-size: 16px;
    color: #6B7280;
    text-align: center;
    max-width: 60%;
    white-space: normal;
    word-break: break-word;
}

.settings-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 40px;
    padding-right: 40px;
}

.line {
    margin-top: 24px;
}

.line .cover {
    display: flex;
    position: relative;
    width: 360px;
    height: 212px;
    border: 1px solid #E1E1E1;
    justify-content: center;
}

.cover > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.tit {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: $table-sub-title-color;
}

textarea {
    padding-left: 8px;
    padding-right: 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 14px;
    color: #707070;
}

</style>